import React, { useEffect, useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage, Modal } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import classNames from 'classnames';
import css from './ListingPage.module.css';

import Gallery from 'react-photo-gallery';

const VIEW_PHOTOS_BUTTON_ID = 'viewPhotosButton';

const ImagesGallery = ({ images, title }) => {
  const hasImages = images && images.length > 0;
  const count = images.length;

  let style = {};
  const gap = 16; // px

  return (
    hasImages && (
      <div className={css.desktopImages}>
        <Gallery
          photos={images}
          renderImage={({ index, key, photo }) => {
            if (count === 1) {
              style = {
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
              };
            } else if (count === 2) {
              style = {
                left: index === 0 ? 0 : `calc(50% + ${gap / 2}px)`,
                top: 0,
                width: `calc(50% - ${gap / 2}px)`,
                height: '100%',
              };
            } else if (count >= 3) {
              if (index === 0) {
                style = {
                  left: 0,
                  top: 0,
                  width: `calc(66% - ${gap / 2}px)`,
                  height: '100%',
                };
              } else if (index === 1) {
                style = {
                  left: `calc(66% + ${gap / 2}px)`,
                  top: 0,
                  width: `calc(34% - ${gap / 2}px)`,
                  height: `calc(50% - ${gap / 2}px)`, // gap below
                };
              } else if (index === 2) {
                style = {
                  left: `calc(66% + ${gap / 2}px)`,
                  top: `calc(50% + ${gap / 2}px)`, // gap above
                  width: `calc(34% - ${gap / 2}px)`,
                  height: `calc(50% - ${gap / 2}px)`,
                };
              } else {
                return null;
              }
            }
            const variants = photo
              ? Object.keys(photo?.attributes?.variants).filter(k => k.startsWith('scaled'))
              : [];
            return (
              <div
                key={key}
                style={{
                  position: 'absolute',
                  ...style,
                }}
              >
                <ResponsiveImage
                  rootClassName={css.rootForImage}
                  alt={title}
                  image={photo}
                  variants={variants}
                />
              </div>
            );
          }}
        />
      </div>
    )
  );
};

const SectionHero = props => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    title,
    listing,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    actionBar,
  } = props;

  const hasImages = listing.images && listing.images.length > 0;
  const firstImage = hasImages ? listing.images[0] : null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];

  const viewPhotosButton = hasImages ? (
    <button id={VIEW_PHOTOS_BUTTON_ID} className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: listing.images.length }}
      />
    </button>
  ) : null;

  return (
    <section className={css.sectionHero} data-testid="hero">
      <div className={css.imageWrapperForSectionHero} onClick={handleViewPhotosClick}>
        {mounted && listing.id ? (
          <div onClick={e => e.stopPropagation()} className={css.actionBarContainerForHeroLayout}>
            {actionBar}
          </div>
        ) : null}

        <ResponsiveImage
          rootClassName={classNames(css.mobileImages, css.rootForImage)}
          alt={title}
          image={firstImage}
          variants={variants}
        />
        <ImagesGallery images={listing.images} title={title} />
        {viewPhotosButton}
      </div>
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        focusElementId={VIEW_PHOTOS_BUTTON_ID}
      >
        <ImageCarousel
          images={listing.images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </section>
  );
};

export default SectionHero;
